module.exports = __webpack_public_path__ + "static/media/partner.644c050c.png";